import { useState } from 'react'
import CreditCard from 'services/CreditCard'
import MastercardLogo from 'icons/mastercard-logo.png'
import VisaLogo from 'icons/visa-logo.png'

import {
  Container,
  MaskedInput,
  Image
} from './styles'

export default function CreditCardInput ({
  name,
  placeholder,
  value,
  onChange: handleChange,
  onBlur: handleBlur
}) {
  const [cardFlag, setCardFlag] = useState (undefined)

  const handleCardNumberChange = value => {
    handleChange (name, value)
    setCardFlag (CreditCard.getCardFlag (value))
  }

  return (
    <Container>
      <MaskedInput
        options={{creditCard: true}}
        placeholder={placeholder}
        value={value}
        onChange={e => handleCardNumberChange (e.target.value)}
        onBlur={handleBlur}
      />
      {/*
        Só há logo destas duas bandeiras. Antes o `else` caía no logo da Visa, então um
        cartão Amex ou Diners aparecia como Visa — o cliente lia como se tivesse digitado o
        cartão errado. Sem logo é melhor do que com o logo de outra bandeira.
      */}
      {['VISA', 'MASTERCARD'].includes (cardFlag) && (
        <Image src={
          cardFlag === 'MASTERCARD' ? MastercardLogo : VisaLogo
        }/>
      )}
    </Container>
  )
}
